<template>
  <div :id="id" @contextmenu.prevent="handler($event)" element="TextComponent" class="sitebuilder-element-container"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :dir="dir()"
       :data-editing="this.editing">
    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" :h="100" ref="draggableResizable"
                             @resizing="onResize" :draggable="false" class="auto-height">
      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config"/>

      <sync-drag :target="this"/>

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-TextComponent'>

        <img
          src="static/images/icons/text.svg"
          style="color: red"
          v-tooltip="{content:$t('ct-large-content-editor'),  class: 'tooltip-custom'}"
          class="svg-icon normal-action"
          @click="editTextModal()"
        />

        <img
          src="static/images/icons/select-toolkit.svg"
          style="color: red"
          v-tooltip="{content: $t('ct-ai-select-from-toolkit'),  class: 'tooltip-custom'}"
          class="svg-icon svg-icon3 normal-action"
          @click="selectFromToolkit()"
        />

        <img
          src="static/images/icons/save-toolkit.svg"
          style="color: red"
          v-tooltip="{content: $t('ct-ai-save-to-toolkit'),  class: 'tooltip-custom'}"
          class="svg-icon svg-icon2 normal-action"
          @click="saveToToolkit()"
        />

        <button class="btn btn-magic-text" @click.prevent="editMagicText()">
          {{ $t('ct-action-magic-text') }}
        </button>
      </options-element-bar>

      <!--      <div v-html="internal_config.order_mobile" style="text-align: center"></div>-->

      <span class="sitebuilder-element desktop-element gradient-config" @dblclick="callEditor" v-show="!this.editing"
            :style="'font-size: '+ internal_config.fontSize + ' !important;font-weight: '+ internal_config.weight "
            :config-properties="JSON.stringify(internal_config)" v-html="internal_config.content"></span>
      <span class="text-center-sb sitebuilder-element mobile-element"
            :style="'font-size: '+ internal_config.fontSizeMobile + ' !important;font-weight: '+ internal_config.weight + ';text-align: '+ internal_config.alignMobile + ' !important;'"
            :config-properties="JSON.stringify(internal_config)" v-html="mobileContent"></span>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>

  </div>
</template>

<script>

  import Model from './Model';
  import Resources from './Resources.vue';
  import OptionsElementBar from "../OptionsElementBar";

  export default {
    name: 'TextComponent',
    props: ['config', 'id', 'preview'],
    components: {
      OptionsElementBar,
      Model,
      Resources
    },
    data() {
      return Model.data();
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },
    methods: {
      selectFromToolkit() {
        let values = {
          action: "open",
          type: "Text",
          save: this.saveFile,
          close: this.closeFile,
          step: 'files'
        };

        this.$root.$emit("fileMananger", values);
      },
      async saveFile(url) {
        try {
          const response = await fetch(url);

          if (!response.ok) throw new Error(`Error to get file: ${response.statusText}`);

          const text = await response.text();

          this.updateContent(text, true);
        } catch (error) {
          console.error('Error to read file:', error);
          this.$snotify.error(this.$t('ct-error-message'));
        }
      },
      closeFile() {
        let values = {
          action: "close",
          type: "Text",
          save: this.saveFile,
          close: this.closeFile,
        };

        this.$root.$emit("fileMananger", values);
      },
      saveToToolkit() {
        const htmlString = this.internal_config.content;
        const temp = document.createElement('div');
        temp.innerHTML = htmlString;
        const textContent = temp.textContent || temp.innerText || '';
        const normalizedText = textContent.replace(/\u00A0/g, ' ').trim();

        let values = {
          textToUpload: normalizedText,
          action: "open",
          type: "Text",
          save: this.saveFile,
          close: this.closeFile,
          step: 'files'
        };

        this.$root.$emit("fileMananger", values);
      },
      editTextModal() {
        this.$root.$emit('editText', this);
      },
      editMagicText() {
        this.$root.$emit('editMagicTextOpen', this);
      },
      animation() {
        return true;
      },
      fontSizeMobileChange() {

        try {

          let elements = document.getElementById(this.$el.id).querySelectorAll('.mobile-element p,.mobile-element span,.mobile-element h1,.mobile-element h2,.mobile-element h3,.mobile-element h4,.mobile-element h5,.mobile-element h6,.mobile-element ul,.mobile-element em,.mobile-element ol,.mobile-element li,.mobile-element big,.mobile-element small');

          for (var i in elements) {
            $(elements[i]).css({'font-size': parseInt(this.internal_config.fontSizeMobile) + 'px'});
          }
        } catch (e) {
        }
      },

      alignMobileChange() {
        try {

          let elements = document.getElementById(this.$el.id).querySelectorAll('.mobile-element p,.mobile-element span,.mobile-element h1,.mobile-element h2,.mobile-element h3,.mobile-element h4,.mobile-element h5,.mobile-element h6,.mobile-element ul,.mobile-element em,.mobile-element ol,.mobile-element li,.mobile-element big,.mobile-element small');

          for (var i in elements) {
            $(elements[i]).css({'text-align': this.internal_config.alignMobile});
          }
        } catch (e) {
        }
      },

      onResize: function (x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        this.$refs.resourcesData.setValuesData(this);
      },

      focusElement(e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this);
        e.stopPropagation();
        e.preventDefault();
      },
      editingTrue() {
        this.editing = true;
      },
      callEditor() {
        if (!this.$props.preview) {

          if (Object.keys(CKEDITOR.instances).length === 0) {
            this.$root.$emit('initTextEditor', this);
          }
        }
      },
      sanitize() {

        this.internal_config.content = this.internal_config.content.replace(/&nbsp;/gi, " ");

        if (this.internal_config.content.indexOf('clean-text-css') !== -1) {
          // this.internal_config.flag = this.$t('ct-neutral');
        this.internal_config.flag = 'Neutral';

          if (this.internal_config.content.indexOf('line-height') !== -1) {
            this.internal_config.content = this.internal_config.content.replace(/display:block;/g, "");
            this.internal_config.content = this.internal_config.content.replace(/line-height:/g, "display:block;line-height:");
          }

        } else {
          this.internal_config.flag = '';
        }
      },
      dir() {
        let defaultLocale = (window.getCookie('languageEditorUser') != null) ? window.getCookie('languageEditorUser') : 'en_US';
        if (
          defaultLocale === 'he_IL' ||
          defaultLocale === 'ja_JP' ||
          defaultLocale === 'ar_AR'
        ) {
          return 'rtl';
        } else return false;
      },
      updateContent(val, replace = false) {
        this.editing = false;

        if (replace) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.internal_config.content || '', 'text/html');

          const getLastElementWithText = (node) => {
            const children = Array.from(node.children);

            for (let i = children.length - 1; i >= 0; i--) {
              const child = children[i];
              const text = child.textContent.replace(/\s+/g, '');
              if (text) return getLastElementWithText(child);
            }

            const ownText = node.textContent.replace(/\s+/g, '');
            return ownText ? node : null;
          };

          const lastElement = getLastElementWithText(doc.body) || doc.body;

          lastElement.textContent = val;

          this.internal_config.content = doc.body.innerHTML.trim();
        } else {
          this.internal_config.content = val;
        }

        this.sanitize();
      },
      replaceLastTextNode(rootElement, newText) {
        const walker = document.createTreeWalker(rootElement, NodeFilter.SHOW_ELEMENT);
        let lastElementWithText = null;

        while (walker.nextNode()) {
          const el = walker.currentNode;
          const text = el.textContent.trim();

          if (text) lastElementWithText = el;
        }

        if (lastElementWithText) {
          lastElementWithText.innerHTML = '';
          lastElementWithText.textContent = newText;
        }
      },
      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },

      editTodo: function (todo) {
        this.internal_config.content = todo;
      },


      edit(e) {
        e.preventDefault();
        this.internal_config.content = prompt('texto', this.internal_config.content);
        this.internal_config.fontSize = prompt('size', this.internal_config.fontSize);
        this.internal_config.fontSizeMobile = prompt('size', this.internal_config.fontSizeMobile);
        this.internal_config.width = prompt('width', this.internal_config.width);
        this.internal_config.weight = prompt('weight', this.internal_config.weight);
      },

      build(config) {
        this.internal_config = config;
        this.sanitize()
      },

      style() {
        return ` width: ${this.internal_config.width};
                 left:  ${this.internal_config.left};
                 z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                 padding-top: ${this.internal_config.paddingTop};
                 padding-left: ${this.internal_config.paddingLeft};
                 padding-right: ${this.internal_config.paddingRight};
                 padding-bottom: ${this.internal_config.paddingBottom};
                 top: ${this.internal_config.top}`;
      },

      handler: function (e) {
        this.$root.$emit('focusElement', this);
        this.$root.$emit('handlerElement', this, true);
        e.stopPropagation();
        e.preventDefault();
      },
    },
    mounted() {
      this.build(this.$props.config);

      let internal_config = window.mergeRecursive(this.props, this.$props.config);
      this.internal_config = {...internal_config, ...this.internal_config};

      if (this.internal_config.content.indexOf('clean-text-css') !== -1) {
        // this.internal_config.flag = this.$t('ct-neutral');
        this.internal_config.flag = 'Neutral';

      } else {
        this.internal_config.flag = '';
      }

      this.fontSizeMobileChange();
      this.alignMobileChange();

      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

        if(this.internal_config.isGradientText){
          let elem = document.getElementById(this.$el.id).querySelector('.gradient-config')
          elem.classList.add('gradient-text')
          document.getElementById(this.$el.id).querySelector('.gradient-text').style.backgroundImage = this.internal_config.textGradientColor
       }

      }

    if(this.internal_config.checkBoxTextBackgroundHover && this.$props.preview){
       let element
          let newColor =  this.internal_config.textBackgroundColorHover
            setTimeout(()=>{
                element = document.getElementById(this.$el.id).querySelector('.gradient-config')
            }, 10);

            document.getElementById(this.$el.id).addEventListener('mouseenter', function () {
                element.style.backgroundColor= newColor;
            })
            document.getElementById(this.$el.id).addEventListener('mouseleave', function () {
                element.style.backgroundColor= "";
            })
     }

      let objIds = [];
      $('[id][element]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });
      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$refs.resourcesData.setValuesData(this);

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {

          for (let i in this.config) {
            this.config[i] = obj[i];
            this.internal_config[i] = obj[i];
          }


          this.$nextTick(() => {
            this.$eventPointer.changePointerState(true);
          })
        }
      });
    },


    computed: {
      // internal_config.alignMobile replace editor alignments
      mobileContent: function () {
        return this.internal_config.content.replace(/text-align: left|text-align: right|text-align: center|text-align: justify/g, "text-align: inherit");
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .gradient-text{
    background-size: 100%;
    -webkit-background-clip: text;
    -moz-background-clip: text;
    -webkit-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
  }
  .auto-height {
    height: auto !important;
  }

  .text-center-sb {
    text-align: center;
  }

  .svg-icon2 {
    width: 30px !important;
  }

  .svg-icon3 {
    width: 36px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Text/Text.vue